import React from "react";
import PropTypes from "prop-types";
import Span from '../common/elements/Span';
import TextWithEllipsis from "./TextWithEllipsis";
export default class ConciseCollection extends React.Component {
  static propTypes = {
    collection: PropTypes.object.isRequired,
    style: PropTypes.object,
    onClick: PropTypes.func
  };

  defaultProps = {
    style: {},
    onClick: () => {
    }
  };

  constructor() {
    super();
  }

  render() {
    //console.log("Inside concise", this.props.collection);
    return (
      <div style={{...styles.asset, ...this.props.style}} onClick={this.props.onClick}>
        <TextWithEllipsis text={this.props.collection.getName()} style={styles.assetName} />
      </div>
    );
  }
}

const styles = {
  asset: {
    width: '100%',
    background: 'var(--primary-header-bg)',
    padding: '5px',
    display: 'flex',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
    fontSize: '14px',
    position: 'relative',
    overflow: 'hidden'
  },
  assetName: {
    margin: 'auto 0.7em',
    color: 'var(--primary-font-color)',
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 1 // Right-aligns any child items
  }
};
